import { render, staticRenderFns } from "./LiveTimestampFuture.vue?vue&type=template&id=4c47c2e2&"
import script from "./LiveTimestampFuture.vue?vue&type=script&lang=js&"
export * from "./LiveTimestampFuture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports